















import { defineComponent, PropType, ref, computed, useRoute, useFetch } from '@nuxtjs/composition-api';
import ContentRelatedEvent from '~/components/partials/Content/ContentRelatedEvent.vue';
import { useRelatedContents } from '~/composables/contents/useRelatedContents';
import { url } from '~/utils';
import { RelatedEvents } from '~/types/modules/contents';
import { EventSummaryResponseSchema } from '~/types/modules/event';

export default defineComponent({
  components: {
    ContentRelatedEvent,
  },
  props: {
    item: {
      type: Object as PropType<RelatedEvents>,
      default: null,
    },
  },
  setup(props) {
    const relatedEvents = ref<EventSummaryResponseSchema[]>([]);
    const eventTags = ref<string[][]>([]);

    const route = useRoute();
    const { getRelatedEvents } = useRelatedContents();

    // お知らせ詳細かどうか
    const isNewsDetail = computed(() => {
      if (!route.value.params.permalink) {
        return false;
      }
      return route.value.path === url('NEWS_DETAIL', { permalink: route.value.params.permalink });
    });

    useFetch(async () => {
      const result = await getRelatedEvents(props.item.event_ids);
      relatedEvents.value = result?.events || [];
      relatedEvents.value.forEach((event) => {
        eventTags.value.push(result?.tags.find((tag) => tag.id === event.id)?.tags || []);
      });
    });

    return {
      relatedEvents,
      isNewsDetail,
      eventTags,
    };
  },
});
